import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { common } from '@ocean/ui'
import trainingLibraryRoutes from 'modules/trainingLibrary/TrainingLibrary/routing/routes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const Surveys = lazy(
  () =>
    import(
      /* webpackChunkName: "TrainingLibrarySurveys" */ 'modules/trainingLibrary/Surveys/pages/Surveys'
    )
)

const SurveysRouting = () => (
  <Suspense fallback={<RouteChangeProgress />}>
    <Switch>
      <Route exact path={routes.root} component={Surveys} />
      <Redirect path='*' to={trainingLibraryRoutes.root} />
    </Switch>
  </Suspense>
)

export default SurveysRouting
